import axiosInstance from '../lib/axios';

// Function to fetch users
export const fetchOrganizations = async ({ queryKey }) => {
    const [_key, { currentPage, search, sortedBy }] = queryKey;

    const response = await axiosInstance.get('/admin/organizations', {
         params: { page: currentPage, limit: 50, search:search, sortedBy :sortedBy }});
    return response.data;
};

// Function to delete user
export const deleteOrganizations = (id) => axiosInstance.delete(`/admin/organizations/${id}`);
